module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-07-e0f80d49da0e8aef751ef4ff7a2673d8.jpg";